import Head from 'next/head';
import Link from 'next/link';

import { ForexGeneralHelpSEO } from '@/utils/constants/MetaData';

const General = () => {
  return (
    <>
      <Head>
        <title>{ForexGeneralHelpSEO.metaTitle}</title>
        <meta
          name="description"
          content={ForexGeneralHelpSEO.metaDescription}
        />
        <meta
          property="og:description"
          content={ForexGeneralHelpSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/help/forex/general/"
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">Forex Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                General
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">General</h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <h2 className="text--black text--semi title">
                  What is the limit of international money transfer in a year?
                </h2>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    The limit for international money transfers set by the
                    Reserve Bank of India under Liberalized Remittance Scheme
                    (LRS) is USD 2,50,000 in one financial year.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  Do I need to visit a Muthoot FinCorp Branch to purchase
                  Forex/Outward remittance/Forex card?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Muthoot FinCorp ONE gives you the option to apply for your
                    multi-currency Forex card online and get it delivered at
                    home. You can also send money abroad (remittance) and reload
                    your existing Muthoot FinCorp ONE Forex card, both online
                    and offline.
                    <br />
                    However, in case you wish to collect cash or sell foreign
                    currency, you will have to visit your nearest Muthoot
                    FinCorp Forex branch
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  What are the different purposes allowed by RBI for which I can
                  purchase Forex ?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    RBI allows the following purposes for which you can purchase
                    Forex for non-trade accounts-
                    <br />
                    <br />
                    (a) Private visits
                    <br />
                    (b) Remittance by tour operators/travel agents to overseas
                    agents/overseas principals (international entity approved by
                    financial regulatory authority of that country for carrying
                    on money transfer activities)/hotels
                    <br />
                    (c) Business travels
                    <br />
                    (d) Fees for participation in global conferences and
                    specialized trainings
                    <br />
                    (e) Remittance for participation in international
                    events/competitions (towards training, sponsorship and prize
                    money)
                    <br />
                    (f) Film shoots
                    <br />
                    (g) Medical treatment abroad
                    <br />
                    (h) Disbursement of crew wages
                    <br />
                    (i) Overseas education
                    <br />
                    (j) Remittance under educational tie up arrangements with
                    universities abroad
                    <br />
                    (k) Remittance towards fees for examinations held in India
                    and abroad, along with additional scoresheets for GRE,
                    TOEFL, etc.
                    <br />
                    (l) Employment and processing, assessment fees for overseas
                    job applications
                    <br />
                    (m) Emigration and emigration consultancy fees
                    <br />
                    (n) Skills/credential assessment fees for intending migrants
                    (o) Visa fees
                    <br />
                    (p) Processing fees for registration of documents as
                    required by the Portuguese and other Governments
                    <br />
                    (q) Registration/subscriptions/membership fees to
                    International Organisations
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFour"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                <p className="text--black text--semi title">
                  What all payment methods can I use to purchase Forex?
                </p>
              </div>
              <div
                id="collapseFour"
                className="collapse"
                aria-labelledby="headingFour"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    At Muthoot FinCorp ONE we accept online payment methods –
                    Net-banking, bank transfer, UPI and debit cards. In addition
                    to the above, we accept cash as well at the Muthoot FinCorp
                    branch, only if the order value is less than Rs. 50,000.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFive"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                <p className="text--black text--semi title">
                  How much is the GST charged on forex services?
                </p>
              </div>
              <div
                id="collapseFive"
                className="collapse"
                aria-labelledby="headingFive"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    The following GST slabs are applicable for Forex
                    transactions:
                    <br />
                    <br />
                    1. 0.18% of the total amount up to Rs. 100,000, subject to a
                    minimum of Rs. 45
                    <br />
                    2. Rs. 180 plus 0.09% of the total amount for an amount
                    between Rs. 1,00,000 and to Rs. 10,00,000
                    <br />
                    3. Rs. 990 plus 0.018% of the total amount exceeding Rs.
                    10,00,000
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSix"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                <p className="text--black text--semi title">
                  What is Tax Collected at Source (TCS) and when is it deducted
                  on my Forex transactions?
                </p>
              </div>
              <div
                id="collapseSix"
                className="collapse"
                aria-labelledby="headingSix"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    According to the RBI guidelines, Tax Collected at Source
                    (TCS) is the tax you have to pay if your order exceeds INR
                    7,00,000. The tax charged will then be 5% for a taxpayer and
                    10% for a non-taxpayer.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSeven"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
              >
                <p className="text--black text--semi title">
                  What all currencies can I purchase from Muthoot FinCorp ONE?
                </p>
              </div>
              <div
                id="collapseSeven"
                className="collapse"
                aria-labelledby="headingSeven"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Muthoot FinCorp ONE offers all major and legally accepted
                    currencies. The list of currencies available are: U.S dollar
                    (USD), Euro (EUR), Japanese Yen (JPY), Pound sterling (GBP),
                    Renminbi (CNY), Australian dollar (AUD), Canadian dollar
                    (CAD), Swiss franc (CHF), Hong Kong dollar (HKD), Singapore
                    dollar (SGD), UAE dirham (AED), Saudi Riyal (SAR), Malaysian
                    ringgit (MYR), Thai baht (THB) and New Zealand dollar (NZD).
                    <br />
                    You can get these anytime within 24* hours. However, the
                    availability of some of these currencies&apos; can be
                    subject to market liquidity.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingEight"
                data-toggle="collapse"
                data-target="#collapseEight"
                aria-expanded="false"
                aria-controls="collapseEight"
              >
                <p className="text--black text--semi title">
                  What is the ‘Block Rate’ feature on Muthoot FinCorp ONE?
                </p>
              </div>
              <div
                id="collapseEight"
                className="collapse"
                aria-labelledby="headingEight"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    The block rate feature on Muthoot FinCorp ONE allows you to
                    lock-in your Forex exchange rate for two days just by paying
                    a nominal premium for your order.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingNine"
                data-toggle="collapse"
                data-target="#collapseNine"
                aria-expanded="false"
                aria-controls="collapseNine"
              >
                <p className="text--black text--semi title">
                  What is the ‘Buy Back Guarantee’ feature on Muthoot FinCorp
                  ONE?
                </p>
              </div>
              <div
                id="collapseNine"
                className="collapse"
                aria-labelledby="headingNine"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    At Muthoot FinCorp ONE we give you the buy-back guarantee
                    feature with a promise to buy your the purchased or
                    left-over currency from you, at the same exchange rate you
                    had purchased from us. You can do this within a period of 15
                    days, from the date of purchase.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTen"
                data-toggle="collapse"
                data-target="#collapseTen"
                aria-expanded="false"
                aria-controls="collapseTen"
              >
                <p className="text--black text--semi title">
                  What is the verification process to buy, sell and reload Forex
                  at Muthoot FinCorp ONE?
                </p>
              </div>
              <div
                id="collapseTen"
                className="collapse"
                aria-labelledby="headingTen"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    At Muthoot FinCorp ONE you can complete your KYC or
                    verification process either through an online video-KYC or
                    by visiting a nearby Muthoot FinCorp Forex Branch with your
                    documents.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default General;
